import React from 'react'
import { Card, Text, Badge, Group, ThemeIcon } from '@mantine/core'
import { LucideIcon } from 'lucide-react'

interface StatisticCardProps {
  title: string
  evolution?: number
  className?: string
  value: number | string
  icon?: LucideIcon
}

const StatisticCard = ({ title, value, icon, evolution, className }: StatisticCardProps) => {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder className={className}>
      <Group justify="space-between" mb="xs">
        <Group gap="xs">
          {icon && (
            <ThemeIcon variant="light" color="brand" size="md">
              {React.createElement(icon, { size: 16 })}
            </ThemeIcon>
          )}
          <Text size="sm" c="dimmed" fw={500}>
            {title}
          </Text>
        </Group>
        {evolution !== undefined && (
          <Badge variant="outline" color={evolution >= 0 ? 'green' : 'red'}>
            {evolution >= 0 ? '+' : ''}{evolution}%
          </Badge>
        )}
      </Group>
      <Text size="xl" fw={700}>
        {value}
      </Text>
    </Card>
  )
}

export default StatisticCard
